export default __webpack_public_path__ + "static/media/product1.a394f013.png";